import { render, staticRenderFns } from "./HelpWidget.vue?vue&type=template&id=3e322fb7&"
import script from "./HelpWidget.vue?vue&type=script&lang=js&"
export * from "./HelpWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports